import KolTable from "@home/pages/studio/paidkol/components/KolTable";
import KolCardService from "@home/pages/studio/paidkol/components/KolCardService";
import KolFilter from "@home/pages/studio/paidkol/components/KolFilter";
import KolTableService from "@home/pages/studio/paidkol/components/KolTableService";

export default {
  KolFilter,
  KolCardService,
  KolTable,
  KolTableService
};